import { render, staticRenderFns } from "./SidemenuItems.vue?vue&type=template&id=f71b6e6e"
import script from "./SidemenuItems.vue?vue&type=script&lang=js"
export * from "./SidemenuItems.vue?vue&type=script&lang=js"
import style0 from "./SidemenuItems.vue?vue&type=style&index=0&id=f71b6e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports